import { createStyles } from '../../styles/helpers'

export default createStyles({
  placeholder: {
    width: '100%',
    height: 'auto',
    filter: 'blur(2px)'
  }
})
